export default "<title-bar [titleName]=\"'View Announcement'\" class=\"p-0 m-0 filterStickey\"></title-bar>\r\n<p>single-view-announcement works!</p>";